<template>
    <v-responsive v-if="ready">
        <v-card class="mt-4">
            <v-card-title class="subtitle-1">카테고리</v-card-title>
            <v-card-text>
                <shop-category-select v-model="product._category" :categories="categories" @input="input"></shop-category-select>
            </v-card-text>
        </v-card>

        <v-row class="mt-4">
            <v-col cols="12" md="7" sm="7">
                <v-card>
                    <v-card-title class="subtitle-1">썸네일</v-card-title>
                    <v-card-text>
                        <product-thumb v-model="product.thumb" @input="input"></product-thumb>
                    </v-card-text>
                </v-card>

                <v-card class="mt-4">
                    <v-card-title class="subtitle-1">상품 이미지</v-card-title>
                    <v-card-text>
                        <draggable v-model="product.images">
                            <transition-group>
                                <product-image v-for="(i, index) in 5" v-model="product.images[index]" :label="`슬라이드${i}`" :key="index" @remove="removeImage" @input="input"></product-image>
                            </transition-group>
                        </draggable>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" md="5" sm="5">
                <v-card>
                    <v-card-title class="subtitle-1">상품 정보</v-card-title>
                    <v-card-text>
                        <v-text-field v-model="product.name" label="상품명" placeholder=" " @input="input"></v-text-field>
                        <v-text-field v-model="product.price" label="판매가" placeholder=" " @input="input"></v-text-field>
                        <v-text-field v-model="product.companyPrice" label="업체가" placeholder=" " @input="input"></v-text-field>
                        <v-text-field v-model="product.stock" label="재고" placeholder=" " :disabled="product.optionEnabled" @input="input"></v-text-field>
                        <v-text-field v-model="product.sequence" label="진열순서" placeholder=" " @input="input"></v-text-field>
                    </v-card-text>
                </v-card>

                <v-card class="mt-4">
                    <v-card-text>
                        <v-text-field v-model="product.meta.manufacturer" label="제조사" placeholder=" " @input="input"></v-text-field>
                        <v-text-field v-model="product.meta.origin" label="원산지" placeholder=" " @input="input"></v-text-field>
                    </v-card-text>
                </v-card>

                <v-card class="mt-4">
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <v-text-field v-model="hashtag" label="해시태그" placeholder=" " dense hide-details @keydown.enter="product.hashtags.push(hashtag); hashtag = null;"></v-text-field>
                            </v-col>
                            <v-col cols="auto" class="pl-0">
                                <v-btn color="primary" small @click="product.hashtags.push(hashtag); hashtag = null; input();"><v-icon small class="mr-2">mdi-tag</v-icon>추가</v-btn>
                            </v-col>
                            <v-col cols="12" class="py-0">
                                <v-chip v-for="(tag, index) in product.hashtags || []" :key="index" close class="mr-1" close-icon="mdi-delete" @click:close="product.hashtags.splice(index, 1); input();">{{ tag }}</v-chip>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

                <v-card class="mt-4">
                    <v-card-title>
                        <v-row>
                            <v-col cols="auto" class="subtitle-1 py-0">브랜드</v-col>
                            <v-spacer></v-spacer>
                            <v-col cols="12" sm="12" md="6" class="py-0">
                                <v-select v-model="product._brand" :items="brands" item-text="name" item-value="_id" dense hide-details class="mt-0" @input="input"></v-select>
                            </v-col>
                        </v-row>
                    </v-card-title>
                </v-card>

                <v-card class="mt-4">
                    <v-card-title>
                        <v-row>
                            <v-col class="subtitle-1 py-0">전시여부 (전시/숨김)</v-col>
                            <v-spacer></v-spacer>
                            <v-col cols="auto" class="py-0">
                                <v-switch v-model="product.display" dense hide-details class="mt-0" @input="input"></v-switch>
                            </v-col>
                        </v-row>
                    </v-card-title>
                </v-card>

                <v-card class="mt-4">
                    <v-card-title>
                        <v-row>
                            <v-col cols="auto" class="subtitle-1 py-0">판매여부 (판매/중단)</v-col>
                            <v-spacer></v-spacer>
                            <v-col cols="auto" class="py-0">
                                <v-switch v-model="product.sale" dense hide-details class="mt-0" @input="input"></v-switch>
                            </v-col>
                        </v-row>
                    </v-card-title>
                </v-card>

                <v-card class="mt-4">
                    <v-card-title>
                        <v-row>
                            <v-col class="subtitle-1 py-0">품절여부 (품절/판매)</v-col>
                            <v-spacer></v-spacer>
                            <v-col cols="auto" class="py-0">
                                <v-switch v-model="product.soldout" dense hide-details class="mt-0" @input="input"></v-switch>
                            </v-col>
                        </v-row>
                    </v-card-title>
                </v-card>
            </v-col>
        </v-row>

        <!-- 할인가 -->
        <product-discount v-model="product" @input="input"></product-discount>

        <!-- 상품옵션 -->
        <product-options v-model="product" @input="input"></product-options>

        <!-- 추가상품 -->
        <product-supplies v-model="product" @input="input"></product-supplies>

        <!-- 배송비 -->
        <product-shippings v-model="product" @input="input"></product-shippings>

        <!-- 도서산간 -->
        <product-islands v-model="product" @input="input"></product-islands>

        <!-- 검색엔진최적화(SEO) -->
        <product-seo v-model="product" @input="input"></product-seo>

        <v-card class="mt-6">
            <v-card-title class="subtitle-1">상품 상세 설명</v-card-title>
            <v-card-text>
                <naver-smarteditor v-model="product.content" rows="10"></naver-smarteditor>
            </v-card-text>
        </v-card>
    </v-responsive>
</template>

<script>
import api from "@/api";

import draggable from 'vuedraggable'
import NaverSmarteditor from '@/components/plugins/naver/naver-smarteditor.vue';

import ShopCategorySelect from '@/components/console/shop/categories/shop-category-select.vue';

import ProductThumb from "@/components/console/shop/products/product-thumb.vue";
import ProductImage from "@/components/console/shop/products/product-image.vue";
import ProductDiscount from '@/components/console/shop/products/product-discount.vue';
import ProductOptions from '@/components/console/shop/products/product-options.vue';
import ProductSupplies from '@/components/console/shop/products/product-supplies.vue';
import ProductShippings from '@/components/console/shop/products/product-shippings.vue';
import ProductIslands from '@/components/console/shop/products/product-islands.vue';
import ProductSeo from '@/components/console/shop/products/product-seo.vue';

export default {
    components: {
        draggable,
        NaverSmarteditor,
        ProductThumb,
        ProductImage,
        ProductDiscount,
        ProductOptions,
        ProductSupplies,
        ProductShippings,
        ProductIslands,
        ProductSeo,
        ShopCategorySelect,
    },
    props: {
        value: { type: Object, default: null }
    },
    data(){
        return {
            ready: null,

            product: this.$props.value,

            hashtag: null,
            brands: [],
            categories: []
        }
    },
    mounted(){
        this.init();
    },

    methods: {
        async init(){
            var { categories } = await api.console.shop.categories.getCategories();
            this.categories = categories;

            var { brands } = await api.console.shop.brands.getBrands();
            this.brands = brands;

            if(this.product.thumb){
                this.product.thumb = await api.getResource(this.product.thumb);
            }

            for(var i in this.product.images){
                if(this.product.images[i]){
                    this.product.images[i] = await api.getResource(this.product.images[i]);
                }
            }

            if(this.product._id === undefined){
                var { summary } = await api.console.shop.products.getProducts({ headers: { limit: 1 } });
                this.product.sequence = summary.totalCount + 1;
            }

            if(this.$route.query._product){
                this.product._id = undefined;

                for(var option of this.product.options){
                    option._id = undefined;
                }
                for(var supply of this.product.supplies){
                    supply._id = undefined;
                }
            }

            this.input();
            this.ready = true;
        },

        input(){
            this.$emit("input", this.product);
        },

        async removeThumb(){
            try{
                if(confirm("상품 썸네일을 삭제하시겠습니까?")){
                    if(this.product._id) await api.console.shop.products.deleteThumb(this.product._id);
                    this.product.thumb = null;
                    this.$emit("input", this.product);
                }
            }
            catch(error){
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },

        async removeImage(index){
            try{
                if(confirm("상품 이미지를 삭제하시겠습니까?")){
                    if(this.product._id) await api.console.shop.products.deleteImage(this.product._id, index);
                    this.product.images[index] = undefined;
                    this.$forceUpdate();
                }
            }
            catch(error){
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },

        
    },
    computed: {
        optionsStock(){
            var stock = 0;
            for(var i in this.product.options){
                stock += this.product.options[i].stock;
            }
            return stock;
        }
    }
}
</script>

<style>
.shop-product-view .weight input { text-align: end; }
.shop-product-view .amount input { text-align: end; }
.shop-product-view .theme--light.v-tabs-items { background-color: transparent !important; }
.shop-product-view .option-groups-headers th { border-bottom: thin solid rgba(0,0,0,.12) }
</style>
